import React, { memo } from 'react';
import styled from 'styled-components';

import { COLORS } from 'theme';

import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.oceanGreenDark};
    background: ${COLORS.oceanGreenLight};
    border-color: ${COLORS.oceanGreen};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.oceanGreenDark};
    }
  }
`;

const MemberPreferredTag = (props) => (
  <StyledTag label="Member Preferred" {...props} />
);

export default memo(MemberPreferredTag);
